import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { formattedText } from 'src/utils/formattedText'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

import DynamicInput from '../DynamicInput/DynamicInput'
import Icon from '../Icon/Icon'
import styles from './TransactionInput.module.scss'

interface TransactionInputProps {
  inputValue: string
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  commission: string
}

const TransactionInput = ({ inputValue, handleChange, commission }: TransactionInputProps) => {
  const { t } = useTranslation()
  const balanceStars = useGlobalStore((state) => state.user?.balance_stars)
  const { pathname } = useLocation()

  const [userReceiveValue, setUserReceiveValue] = useState<number>(0)

  useEffect(() => {
    setUserReceiveValue((+inputValue / 100) * 0.95)
  }, [inputValue])

  if (!balanceStars) {
    return null
  }

  const userBalance = formattedText(Number(balanceStars?.toFixed(2)))

  return (
    <div className={styles.input}>
      <div className={styles.input_subtitle}>
        <p>{t('transaction_input.balance', { balance: userBalance })}</p>
        <Icon name='starSmall' />
      </div>

      <DynamicInput onChange={handleChange} inputValue={inputValue} type='number' inputMode='numeric' placeholder='0' />

      <div className={styles.input_subtitle}>
        <p>
          {pathname.includes('/withdrawal/ton') ? (
            t('transaction_input.user_receive', { value: userReceiveValue })
          ) : (
            <>
              {commission !== t('transaction_input.not_commission')
                ? t('transaction_input.commission', { commission })
                : commission}
            </>
          )}
        </p>
        <Icon name={pathname.includes('/withdrawal/ton') ? 'ton__icon' : 'starSmall'} />
      </div>
    </div>
  )
}

export default TransactionInput
